// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.card {
  border: 1px solid #e8ecf1;
  border-radius: 12px;
  color: var(--undp-jtf-btn-dark-color) !important;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
  overflow: hidden;
}
.card:hover:not(.active) {
  border-color: #cbd5e1;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}
.card.active {
  border-color: var(--undp-jtf-btn-dark-color);
  border-top-width: 4px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
}
.card.active .card-body .card-title {
  color: var(--undp-jtf-text-color);
}
.card.active .arrow-opacity {
  opacity: 1;
  color: var(--undp-jtf-btn-dark-color);
}
.card.report-low {
  border-top: 4px solid #22c55e;
}
.card.report-medium {
  border-top: 4px solid #eab308;
}
.card.report-high, .card.report-critical {
  border-top: 4px solid #ef4444;
}
.card .card-body {
  padding: 1rem 1.1rem;
  cursor: pointer;
}
.card .linked-posts {
  border-radius: 8px;
  border: solid 1px var(--undp-jtf-dark-bg-color);
}
.card .priority {
  right: 15px;
  position: absolute;
  bottom: 10px;
}

.flex-card-row-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: flex-start;
  gap: 0.5rem;
}

.flex-card-column-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.word-wrap {
  word-break: break-word;
  font-size: 0.95rem;
  line-height: 1.35;
}

.flex-card-row {
  display: flex;
  flex-grow: 1;
  min-width: 0;
  width: calc(100% - 2rem);
}

.flex-card-report-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  font-size: 0.8125rem;
  color: #64748b;
}

.arrow-opacity {
  opacity: 0.45;
  transition: opacity 0.15s ease, color 0.15s ease;
}

.incident-type-circle {
  background-color: #e0f2fe;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.incident-type-circle img {
  height: 28px;
  width: auto;
}

.pad-left-15 {
  padding-left: 0;
}

.pad-left-4 {
  padding-left: 4px;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post/post.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,yBAAA;EACA,mBAAA;EACA,gDAAA;EACA,gBAAA;EACA,4CAAA;EACA,8EAAA;EACA,gBAAA;AAEF;AAAE;EACE,qBAAA;EACA,6CAAA;EACA,2BAAA;AAEJ;AACE;EACE,4CAAA;EACA,qBAAA;EACA,0DAAA;EACA,4CAAA;AACJ;AACI;EACE,iCAAA;AACN;AAEI;EACE,UAAA;EACA,qCAAA;AAAN;AAIE;EACE,6BAAA;AAFJ;AAKE;EACE,6BAAA;AAHJ;AAME;EAEE,6BAAA;AALJ;AAQE;EACE,oBAAA;EACA,eAAA;AANJ;AASE;EACE,kBAAA;EACA,+CAAA;AAPJ;AAUE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AATF;;AAYA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;AATF;;AAYA;EACE,aAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;AATF;;AAYA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AATF;;AAYA;EACE,aAAA;EACA,gDAAA;AATF;;AAYA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AATF;;AAYA;EACE,YAAA;EACA,WAAA;AATF;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,iBAAA;AATF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\n\n.card {\n  border: 1px solid #e8ecf1;\n  border-radius: 12px;\n  color: var(--undp-jtf-btn-dark-color) !important;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;\n  overflow: hidden;\n\n  &:hover:not(.active) {\n    border-color: #cbd5e1;\n    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);\n    transform: translateY(-1px);\n  }\n\n  &.active {\n    border-color: var(--undp-jtf-btn-dark-color);\n    border-top-width: 4px;\n    background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);\n    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);\n\n    .card-body .card-title {\n      color: var(--undp-jtf-text-color);\n    }\n\n    .arrow-opacity {\n      opacity: 1;\n      color: var(--undp-jtf-btn-dark-color);\n    }\n  }\n\n  &.report-low {\n    border-top: 4px solid #22c55e;\n  }\n\n  &.report-medium {\n    border-top: 4px solid #eab308;\n  }\n\n  &.report-high,\n  &.report-critical {\n    border-top: 4px solid #ef4444;\n  }\n\n  .card-body {\n    padding: 1rem 1.1rem;\n    cursor: pointer;\n  }\n\n  .linked-posts {\n    border-radius: 8px;\n    border: solid 1px var(--undp-jtf-dark-bg-color);\n  }\n\n  .priority {\n    right: 15px;\n    position: absolute;\n    bottom: 10px;\n  }\n}\n\n.flex-card-row-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.flex-card-column-wrapper {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.word-wrap {\n  word-break: break-word;\n  font-size: 0.95rem;\n  line-height: 1.35;\n}\n\n.flex-card-row {\n  display: flex;\n  flex-grow: 1;\n  min-width: 0;\n  width: calc(100% - 2rem);\n}\n\n.flex-card-report-info-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  font-size: 0.8125rem;\n  color: #64748b;\n}\n\n.arrow-opacity {\n  opacity: 0.45;\n  transition: opacity 0.15s ease, color 0.15s ease;\n}\n\n.incident-type-circle {\n  background-color: #e0f2fe;\n  width: 48px;\n  height: 48px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.incident-type-circle img {\n  height: 28px;\n  width: auto;\n}\n\n.pad-left-15 {\n  padding-left: 0;\n}\n\n.pad-left-4 {\n  padding-left: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
